import React from 'react';

import {observer} from 'mobx-react';

import {useStores} from '../../../Hooks';
import StyledOptionSelect from '../SettingsShared/StyledOptionSelect';

const labelClass = 'block mb-1 text-[11px] font-semibold text-main-normal tracking-[0.5px]';
const subLabelClass = 'text-xs text-main-hover mb-1';
const descClass = 'text-xs text-main-hover mt-1';

const DefaultSettingsSection = observer(({isRolesPermittedByDefault, onChange, hideTitle}) => {
    const {generalStore} = useStores();

    const options = [
        {value: true, title: generalStore.translate('permitted') || 'Permitted'},
        {value: false, title: generalStore.translate('notPermitted') || 'Not Permitted'},
    ];

    return (
        <div>
            {!hideTitle && <span className={labelClass}>DEFAULT SETTINGS</span>}
            <div className={hideTitle ? '' : 'mt-2'}>
                <label className={subLabelClass}>{generalStore.translate('ByDefault,RolesInAFlowAreAsFollows:')}</label>
                <StyledOptionSelect
                    value={!!isRolesPermittedByDefault}
                    onChange={(v) => onChange(v === true || v === 'true')}
                    options={options}
                    sx={{width: '100%'}}
                />
                <p className={descClass}>{generalStore.translate('ThisSettingDeterminesWhetherNewRolesOrAllRolesInANewFlowWillBeAutomaticallyPermittedByDefault.')}</p>
            </div>
        </div>
    );
});

export default DefaultSettingsSection;
